import { FC } from "react"
import { Container } from "@mui/material"
import { useTitle } from "@/core/hooks"
import { MetabaseEmbed } from "@/modules/pr/components"
import { Metabase } from "@/modules/pr/interfaces"

interface IProps {}

export const AnalyticsPage: FC<IProps> = (props) => {
  useTitle(`PR ADV - Аналитика`)

  return (
    <Container maxWidth={false} sx={{ height: "100vh" }}>
      <MetabaseEmbed type={Metabase.EmbedType.dashboard} id={104} />
    </Container>
  )
}
